/*
  "More colours" / "More in this range": on a product page, show the other
  products of the same model or range as small tiles.

  - Colours: any product titled "Model - Colour" shows the other colours of
    that model (same brand, same title before the " - ").
  - Range: arriving from a brand page tile that stands for a whole range
    ("Wookah Abstract"), the address carries the range and the row shows it.

  Switching is instant: the other pages are fetched quietly in the background
  and, on a click, the product area is swapped in place instead of loading a
  whole new page.
*/
(function () {
  var VISIBLE = 12;
  var pages = {};          // address -> promise of that page's HTML
  var lists = {};          // search address -> promise of the sibling list

  function getList(url) {
    if (!lists[url]) {
      var saved = null;
      try { saved = sessionStorage.getItem('siblings:' + url); } catch (e) {}
      if (saved) {
        lists[url] = Promise.resolve(saved);
      } else {
        lists[url] = fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : '[]'; })
          .then(function (text) {
            try { sessionStorage.setItem('siblings:' + url, text); } catch (e) {}
            return text;
          });
      }
    }
    return lists[url];
  }

  function getPage(url) {
    if (!pages[url]) {
      pages[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.text();
      });
      pages[url].catch(function () { delete pages[url]; });
    }
    return pages[url];
  }

  // Swap the product area for the one in the fetched page. Returns false when
  // it is safer to load the page normally.
  function swap(html, url) {
    var next = new DOMParser().parseFromString(html, 'text/html');
    var currentBox = document.querySelector('[data-siblings]');
    var currentSection = currentBox && currentBox.closest('.shopify-section');
    if (!currentSection || !window.productPage) return false;
    var nextSection = next.getElementById(currentSection.id);
    if (!nextSection) return false;

    // App widgets inside the product area cannot be restarted reliably, so if
    // one is showing something here, or the next product is sold on
    // subscription, load the page normally instead.
    var apps = currentSection.querySelectorAll('.shopify-app-block');
    for (var i = 0; i < apps.length; i++) {
      if (apps[i].textContent.trim() !== '' || apps[i].querySelector('input, select, button, iframe, img')) return false;
    }
    var nextHtml = nextSection.innerHTML;
    if (nextHtml.indexOf('selling_plan_groups') !== -1 &&
        nextHtml.indexOf('selling_plan_groups&quot;:[]') === -1 &&
        nextHtml.indexOf('"selling_plan_groups":[]') === -1) return false;

    var keepScroll = window.scrollY;
    currentSection.innerHTML = nextSection.innerHTML;

    var reviewsNow = document.querySelector('.product-reviews-section');
    var reviewsNext = next.querySelector('.product-reviews-section');
    if (reviewsNow && reviewsNext) reviewsNow.innerHTML = reviewsNext.innerHTML;

    // Forget the previous product's gallery so the new one is set up cleanly.
    window.productGalleryMedia = [];
    window.thumbnailGalleryMedia = [];
    try {
      window.productPage.init();
      window.productPage.runOptionSelector();
      window.productPage.initializeQuantityBox();
    } catch (e) {
      return false;
    }
    if (window.shishagearRestoreGallery) window.shishagearRestoreGallery();
    // Scripts put in with innerHTML don't run: restart the ones marked data-sg-rerun (add-on box, variant watch)
    Array.prototype.forEach.call(currentSection.querySelectorAll('script[data-sg-rerun]'), function (old) {
      var s = document.createElement('script');
      s.setAttribute('data-sg-rerun', '');
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });

    document.title = next.title;
    var canonical = document.querySelector('link[rel="canonical"]');
    var nextCanonical = next.querySelector('link[rel="canonical"]');
    if (canonical && nextCanonical) canonical.href = nextCanonical.href;
    history.pushState({ siblings: true }, '', url);
    window.scrollTo(0, keepScroll);

    build();
    return true;
  }

  function build() {
    var box = document.querySelector('[data-siblings]');
    if (!box || box.getAttribute('data-built')) return;
    box.setAttribute('data-built', 'true');

    var title = box.getAttribute('data-title') || '';
    var vendor = box.getAttribute('data-vendor') || '';
    var handle = box.getAttribute('data-handle') || '';
    var root = box.getAttribute('data-root') || '/';

    var params = new URLSearchParams(window.location.search);
    var family = (params.get('family') || '').toLowerCase().trim();
    var familyWith = (params.get('with') || '').toLowerCase().trim();
    var rangeMode = family !== '' && title.toLowerCase().indexOf(family) === 0;

    var base, nameOf;
    if (rangeMode) {
      base = title.slice(0, family.length);
      nameOf = function (t) {
        var name = t.slice(family.length).trim();
        if (familyWith && name.toLowerCase().slice(-familyWith.length) === familyWith) name = name.slice(0, -familyWith.length).trim();
        return name;
      };
    } else {
      var parts = title.split(/\s[-–]\s/);
      if (parts.length < 2) return;
      base = parts[0].trim();
      nameOf = function (t) { return t.slice(base.length).replace(/^\s[-–]\s/, '').trim(); };
    }

    var suffix = rangeMode ? '?family=' + encodeURIComponent(family) + '&with=' + encodeURIComponent(familyWith) : '';
    var listUrl = root + 'search?type=product&options[prefix]=last&view=siblings&q=' + encodeURIComponent('"' + base + '"');

    getList(listUrl).then(function (text) {
      var items;
      try { items = JSON.parse(text); } catch (e) { return; }

      // The whole family, this product included, in one fixed order so the
      // row does not shuffle when switching.
      var members = items.filter(function (it) {
        if (it.multi || it.vendor !== vendor) return false;
        if (/random colour/i.test(it.title)) return false;
        if (it.handle === handle) return true;
        if (rangeMode) {
          var lower = it.title.toLowerCase();
          return lower.indexOf(family + ' ') === 0 && (familyWith === '' || lower.indexOf(familyWith) !== -1) && it.available !== false;
        }
        return it.title.indexOf(base + ' - ') === 0 || it.title.indexOf(base + ' – ') === 0;
      });
      var others = members.filter(function (it) { return it.handle !== handle; });
      if (!others.length) return;

      members.sort(function (a, b) {
        if (a.available !== b.available) return a.available ? -1 : 1;
        return a.title.localeCompare(b.title);
      });

      var label = document.createElement('p');
      label.className = 'siblings__label';
      label.textContent = (rangeMode ? 'More in this range (' : 'More colours (') + others.length + ')';

      var list = document.createElement('div');
      list.className = 'siblings__list';

      members.forEach(function (it, i) {
        var current = it.handle === handle;
        var el = document.createElement(current ? 'span' : 'a');
        var name = nameOf(it.title);
        el.className = 'siblings__item' + (current ? ' is-current' : '') + (it.available === false ? ' is-sold-out' : '');
        el.title = name + (it.available === false ? ' (sold out)' : '');
        if (i >= VISIBLE && !current) el.classList.add('is-extra');
        if (it.image) {
          var img = document.createElement('img');
          img.src = it.image; img.alt = ''; img.width = 64; img.height = 64;
          el.appendChild(img);
        }
        var text = document.createElement('span');
        text.className = 'siblings__name';
        text.textContent = name;
        el.appendChild(text);

        if (!current) {
          var url = root + 'products/' + it.handle + suffix;
          el.href = url;
          el.addEventListener('click', function (event) {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button) return;
            event.preventDefault();
            box.classList.add('is-switching');
            getPage(url)
              .then(function (html) { if (!swap(html, url)) window.location.href = url; })
              .catch(function () { window.location.href = url; });
          });
        }
        list.appendChild(el);
      });

      box.appendChild(label);
      box.appendChild(list);

      if (members.length > VISIBLE + 1) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'siblings__more';
        more.textContent = 'Show all ' + members.length;
        more.addEventListener('click', function () { box.classList.add('is-open'); more.remove(); });
        box.appendChild(more);
      }
      box.hidden = false;

      // Fetch the other pages quietly so a click is instant.
      var warm = function () {
        others.slice(0, 8).forEach(function (it) {
          if (it.available !== false) getPage(root + 'products/' + it.handle + suffix);
        });
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 2500 });
      else setTimeout(warm, 1200);
    }).catch(function () {});
  }

  // Back and forward buttons after an in-place switch: load that page properly.
  window.addEventListener('popstate', function () { window.location.reload(); });

  build();
})();
